import dayjs from "dayjs";
import { TbSailboat } from "react-icons/tb";
import { useQuery } from "@apollo/client";
import Spinner from "../components/Spinner";

import { BOOKINGS_COUNT_BY_DAY } from "../graphql/querys";
import { useAuthContext } from "../providers/AuthProvider";
import { useContext, useEffect, useState } from "react";
import { CurrentDateContext } from "../context/CurrentDateContext";

interface ICardDay {
  isActive?: boolean;
  date: any;
  isToday: boolean;
  reservas: any;
  isDriver?: boolean;
}

export default function CardDay({
  isActive,
  date,
  isToday,
  isDriver,
}: ICardDay) {
  const { globalData } = useAuthContext();

  const {currentDate} = useContext(CurrentDateContext)

  const today = dayjs();
  const day = dayjs(date.fecha)
    .subtract(globalData.business.publishDaysBefore, "day")
    .hour(parseInt(globalData.business.publishTime.slice(0, 2)))
    .minute(parseInt(globalData.business.publishTime.slice(3, 5)))
    .second(0);

  const { data, loading,  } = useQuery(BOOKINGS_COUNT_BY_DAY, {
    fetchPolicy: 'cache-and-network',
    variables: {
      businessId: globalData?.business.id,
      date: dayjs(date?.fecha).format(),
      employeeId: isDriver ? +globalData?.me.id : null,
    },
  });

  const countsPerDay = data?.bookingsCountByDay;

  const [showDay, setShowDay] = useState<boolean>(false);

  useEffect(() => {
    let show = false;
      const diasRef = dayjs(currentDate)
        .startOf("day")
        .diff(dayjs().startOf("day"), "days");

      if (diasRef < globalData.business.publishDaysBefore)
        show = true;
      else if (diasRef === globalData.business.publishDaysBefore) {
        const horaMinutos = globalData.business.publishTime.substring(
          0,
          5
        );
        const arrayHoraMinutos = horaMinutos.split(":");

        const horas = arrayHoraMinutos[0];
        const minutos = arrayHoraMinutos[1];
        const r = dayjs().set("hour", horas).set("minute", minutos);
        console.log(
          "r de comp",
          r.format(),
          r.diff(dayjs(), "minute")
        );
        if (r.diff(dayjs(), "minute") <= 0) show = true; // si ya paso la hora del dia de publicacion mostramos dia
      }

      setShowDay(show);
  }, [currentDate])

  console.log({
    a1: date.fecha,
    a2: dayjs(currentDate).format('YYYY-MM-DD')
  })
  
  return (
    <div
      className={`p-[7px] h-[100px] flex w-[100px] rounded-md flex-col justify-between border ${
        isToday && isActive
          ? "border-darkBlue"
          : isToday
          ? "border-darkYellow"
          : isActive
          ? "border-darkBlue"
          : "border-darkBlue"
      } ${
        isToday && isActive
          ? "bg-darkBlue"
          : isToday
          ? "bg-darkYellow"
          : isActive
          ? "bg-darkBlue"
          : "white"
      }`}
    >
      <div>
        <div className="flex items-center justify-end">
          <span
            className={`text-xl block ${
              isToday && isActive
                ? "text-white"
                : isToday
                ? "text-darkBlue"
                : isActive
                ? "text-white"
                : "text-darkBlue"
            }`}
          >
            <TbSailboat />
          </span>
          <span
            className={`ml-[5px] block font-bold ${
              isToday && isActive
                ? "text-white"
                : isToday
                ? "text-darkBlue"
                : isActive
                ? "text-white"
                : "text-darkBlue"
            }`}
          >
            {isDriver && day.isAfter(today) ? (
              dayjs(currentDate).format('YYYY-MM-DD') === date.fecha && !showDay ? <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_3748_15178)">
              <path d="M12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2ZM12 4C9.87827 4 7.84344 4.84285 6.34315 6.34315C4.84285 7.84344 4 9.87827 4 12C4 14.1217 4.84285 16.1566 6.34315 17.6569C7.84344 19.1571 9.87827 20 12 20C14.1217 20 16.1566 19.1571 17.6569 17.6569C19.1571 16.1566 20 14.1217 20 12C20 9.87827 19.1571 7.84344 17.6569 6.34315C16.1566 4.84285 14.1217 4 12 4ZM12 6C12.2449 6.00003 12.4813 6.08996 12.6644 6.25272C12.8474 6.41547 12.9643 6.63975 12.993 6.883L13 7V11.586L15.707 14.293C15.8863 14.473 15.9905 14.7144 15.9982 14.9684C16.006 15.2223 15.9168 15.4697 15.7488 15.6603C15.5807 15.8508 15.3464 15.9703 15.0935 15.9944C14.8406 16.0185 14.588 15.9454 14.387 15.79L14.293 15.707L11.293 12.707C11.1376 12.5514 11.0378 12.349 11.009 12.131L11 12V7C11 6.73478 11.1054 6.48043 11.2929 6.29289C11.4804 6.10536 11.7348 6 12 6Z" fill="white"/>
              </g>
              <defs>
              <clipPath id="clip0_3748_15178">
              <rect width="24" height="24" fill="#fff"/>
              </clipPath>
              </defs>
              </svg>
               : <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_3749_15182)">
<path d="M12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2ZM12 4C9.87827 4 7.84344 4.84285 6.34315 6.34315C4.84285 7.84344 4 9.87827 4 12C4 14.1217 4.84285 16.1566 6.34315 17.6569C7.84344 19.1571 9.87827 20 12 20C14.1217 20 16.1566 19.1571 17.6569 17.6569C19.1571 16.1566 20 14.1217 20 12C20 9.87827 19.1571 7.84344 17.6569 6.34315C16.1566 4.84285 14.1217 4 12 4ZM12 6C12.2449 6.00003 12.4813 6.08996 12.6644 6.25272C12.8474 6.41547 12.9643 6.63975 12.993 6.883L13 7V11.586L15.707 14.293C15.8863 14.473 15.9905 14.7144 15.9982 14.9684C16.006 15.2223 15.9168 15.4697 15.7488 15.6603C15.5807 15.8508 15.3464 15.9703 15.0935 15.9944C14.8406 16.0185 14.588 15.9454 14.387 15.79L14.293 15.707L11.293 12.707C11.1376 12.5514 11.0378 12.349 11.009 12.131L11 12V7C11 6.73478 11.1054 6.48043 11.2929 6.29289C11.4804 6.10536 11.7348 6 12 6Z" fill="#1B4965"/>
</g>
<defs>
<clipPath id="clip0_3749_15182">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>

              
            ) : loading ? (
              <Spinner />
            ) : (
              countsPerDay
            )}
          </span>
        </div>
      </div>

      <div>
        <p
          className={`text-[28px] uppercase font-bold ${
            isToday && isActive
              ? "text-white"
              : isToday
              ? "text-darkBlue"
              : isActive
              ? "text-white"
              : "text-darkBlue"
          }`}
        >
          {/* {format(new Date(date?.fecha), "EEEEEE")} */}
          {dayjs(date?.fecha).format("dd")}
        </p>
        <p
          className={`text-sm -mt-[3px] font-medium ${
            isToday && isActive
              ? "text-white"
              : isToday
              ? "text-darkBlue"
              : isActive
              ? "text-white"
              : "text-darkBlue"
          }`}
        >
          {dayjs(date?.fecha).format("DD MMM")}
        </p>
      </div>
    </div>
  );
}
